import { render, staticRenderFns } from "./PunchsTable.vue?vue&type=template&id=33f9b366&scoped=true"
import script from "./PunchsTable.vue?vue&type=script&lang=js"
export * from "./PunchsTable.vue?vue&type=script&lang=js"
import style0 from "./PunchsTable.vue?vue&type=style&index=0&id=33f9b366&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f9b366",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33f9b366')) {
      api.createRecord('33f9b366', component.options)
    } else {
      api.reload('33f9b366', component.options)
    }
    module.hot.accept("./PunchsTable.vue?vue&type=template&id=33f9b366&scoped=true", function () {
      api.rerender('33f9b366', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flow/attendances/punchs/components/PunchsTable.vue"
export default component.exports